/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { FC } from 'react';
import { styled } from 'linaria/react';
import { useDidMount } from '@mtsbank/ui-kit';
import { OldHeader } from '@widgets/header';
import { OldFooter } from '@widgets/footer';
import { useSetBreadCrumbsCurrentPath } from '@shared/lib/breadcrumbs';
import { newYearGiveawayResultsLoadedCyberGtm } from '@shared/lib/gtm';
import { withTheme } from '@shared/lib';
import SnowfallAnimation from './SnowfallAnimation';
import WinnersSection from './WinnersSection';
import AdditionalWinnersSection from './AdditionalWinnersSection';
const NewYearGiveawayResultsPageView: FC = () => {
  useSetBreadCrumbsCurrentPath('Новогодний розыгрыш Steam');
  useDidMount(() => {
    newYearGiveawayResultsLoadedCyberGtm();
  });
  return <NewYearGiveawayResultsPageViewWrapper>
      <HeaderWrapper>
        <OldHeader />
      </HeaderWrapper>
      <ContentWrapper>
        <WinnersSection />
        <AdditionalWinnersSection />
      </ContentWrapper>
      <OldFooter />
      <SnowfallAnimation />
    </NewYearGiveawayResultsPageViewWrapper>;
};
export default NewYearGiveawayResultsPageView;
const _exp = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.primary;
const NewYearGiveawayResultsPageViewWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "NewYearGiveawayResultsPageViewWrapper",
  class: "ntcbe11",
  propsAsIs: false,
  vars: {
    "ntcbe11-0": [_exp()]
  }
}));
const HeaderWrapper = /*#__PURE__*/styled('div')({
  name: "HeaderWrapper",
  class: "h1uuqbfw",
  propsAsIs: false
});
const ContentWrapper = /*#__PURE__*/styled('div')({
  name: "ContentWrapper",
  class: "c149x57o",
  propsAsIs: false
});

require("./NewYearGiveawayResultsPageView.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./NewYearGiveawayResultsPageView.tsx");